import React from "react";
import Container from "@mui/material/Container";
import Box from "components/common/Box";
import Stack from "components/common/Stack";
import ProfileIdentityCard from "./ProfileIdentityCard";
import ContactServiceCard from "./ContactServiceCard";
import ProfileMenuList from "./ProfileMenuList";
import ProfileSectionHeaderRow from "./ProfileSectionHeaderRow";
import PlanGroupHeader from "./PlanGroupHeader";
import PlanDetailCard from "./PlanDetailCard";
import NoProductsCard from "./NoProductsCard";
import AllInOneFooter from "components/allInOneDashboard/AllInOneFooter";

/**
 * Figma node 7537:53865 ("Profile") — full web + responsive Profile page.
 * Sidebar (identity / contact-RM / menu links) + Main content (risk
 * profile, subscription & plans grouped into Investing Essentials and
 * Private Wealth).
 */
const AllInOneProfilePage = ({
  identity,
  menuItems = [],
  onContactRM,
  riskProfileSlot,
  onViewBillingHistory,
  essentialsGroup,
  privateWealthGroup,
}) => (
  <>
  <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3, md: 4, lg: 7.5 }, py: { xs: 2.5, md: 5 } }}>
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        alignItems: "flex-start",
        gap: { xs: 3, md: 6 },
      }}
    >
      {/* Sidebar */}
      <Box sx={{ width: { xs: "100%", md: 420 }, flexShrink: 0 }}>
        <Stack spacing={1.75} sx={{ width: "100%" }}>
          <ProfileIdentityCard {...identity} />
          <ContactServiceCard onContactClick={onContactRM} />
          <ProfileMenuList items={menuItems} />
        </Stack>
      </Box>

      {/* Main content */}
      <Box sx={{ flex: 1, minWidth: 0, width: "100%" }}>
        <Stack spacing={{ xs: 3, md: 4 }} sx={{ width: "100%" }}>
          {riskProfileSlot}

          <ProfileSectionHeaderRow
            title="Subscription & Plans"
            linkLabel="View Billing History"
            onLinkClick={onViewBillingHistory}
          />

          <Stack spacing={{ xs: 2, md: 3 }} sx={{ width: "100%" }}>
            <PlanGroupHeader
              variant="light"
              icon="/images/product-info/investing-essentials-icon.png"
              title="Investing Essentials"
              activeCount={essentialsGroup.activeCount}
            />
            {essentialsGroup.plans.length ? (
              essentialsGroup.plans.map((plan) => (
                <PlanDetailCard key={plan.key} {...plan} />
              ))
            ) : (
              <NoProductsCard />
            )}
          </Stack>

          <Stack spacing={{ xs: 2, md: 3 }} sx={{ width: "100%" }}>
            <PlanGroupHeader
              variant="gold"
              icon="/images/product-info/private-wealth-icon.png"
              iconWidth={33}
              iconHeight={44}
              title="Private Wealth"
              activeCount={privateWealthGroup.activeCount}
            />
            {privateWealthGroup.plans.length ? (
              privateWealthGroup.plans.map((plan) => (
                <PlanDetailCard key={plan.key} {...plan} />
              ))
            ) : (
              <NoProductsCard />
            )}
          </Stack>
        </Stack>
      </Box>
    </Box>
  </Container>
  <AllInOneFooter />
  </>
);

export default AllInOneProfilePage;
